import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { moneyTransferApi } from 'src/Services/API';

const useFetchMoneyTransfers = (year?: number) => {
  const { assetId } = useParams<{ assetId: string }>();

  return useQuery(
    ['money-transfers', assetId, year],
    () => {
      if (!assetId) throw new Error('Asset ID is missing');
      return moneyTransferApi.findAll(assetId, year);
    },
    {
      enabled: !!assetId,
    }
  );
};

export default useFetchMoneyTransfers;
